import type { NextOrderDetailsData } from '@/types'
import { cn } from '@utils'
import { CONTROL_BUTTONS, controlToggleField } from '../utils/portalActions'

interface OmpNextOrderSkeletonProps {
  data?: NextOrderDetailsData
  variant?: 'detail'
}

const ACTION_TOGGLES = CONTROL_BUTTONS.map(control => controlToggleField(control.key))

// The section config is available before the item request resolves, so the pill count
// matches what the real card will render instead of being guessed.
function actionCount(data: NextOrderDetailsData | undefined): number {
  if (!data) {
    return 2
  }
  const enabled = ACTION_TOGGLES.filter(key => (data as Record<string, unknown>)[key]).length
  return Math.min(Math.max(enabled, 1), 3)
}

const OmpNextOrderSkeleton = ({ data, variant }: OmpNextOrderSkeletonProps) => {
  const pills = Array.from({ length: actionCount(data) })

  return (
    <div className="omp-next-order-card" aria-hidden="true">
      <div className={cn('omp-next-order-body', variant === 'detail' && 'omp-detail-card-body')}>
        <div className="omp-next-head-group">
          <div className="omp-next-detail-head">
            <div className="omp-next-detail-idrow">
              <span className="skeleton omp-skel-line omp-skel-w-25" />
              <span className="skeleton omp-skel-pill" />
            </div>
            <span className="skeleton omp-skel-line omp-skel-line-md omp-skel-w-60" />
            <span className="skeleton omp-skel-line omp-skel-w-35" />
          </div>
        </div>

        <div className="omp-skel-btns-row">
          {pills.map((_, i) => (
            <span className="skeleton omp-skel-btn" key={i} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default OmpNextOrderSkeleton
